/**
 * Activities on the OT and SLP data sheets.
 *
 * They are a LIST now, but entries recorded before that change stored a single
 * string, and those rows are still read on the history tab and every View Data
 * screen. Both shapes have to survive a read, so the conversion lives here rather
 * than being re-inlined at each render site — an array rendered directly by React
 * concatenates its items with no separator ("ab"), which is how the old inline
 * `{g.activities}` silently mangled a migrated row.
 */

/** Either shape in, a clean array of non-empty strings out. */
export const activityLines = (activities) => {
  if (Array.isArray(activities)) return activities.map((a) => String(a || '').trim()).filter(Boolean);
  const s = String(activities || '').trim();
  return s ? [s] : [];
};

/**
 * Display form: numbered and newline-joined, em dash when there is nothing.
 * Render inside an element with `white-space: pre-wrap` so the newlines show.
 */
export const formatActivityList = (activities) => {
  const lines = activityLines(activities);
  return lines.length ? lines.map((a, i) => `${i + 1}. ${a}`).join('\n') : '—';
};
